import React from "react";
import { useFormikContext } from "formik";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import { useDispatch } from "react-redux";
import { setAppShowRemainingForm } from "../../../../redux/slices/appSettingsSlice";
import "./SelectedTeamRoleCardExtraTitle.scss";

const SelectedTeamRoleCardExtraTitle = ({ setAppTeamModalOpen }) => {
    const { setFieldValue } = useFormikContext();
    const dispatch = useDispatch();
    return (
        <div className="team-role-card-selected-extra-title">
            <button
                type="button"
                className="team-role-card-selected-extra-title__button"
                onClick={() => {
                    dispatch(setAppTeamModalOpen(true));
                }}
                aria-label="Change team"
            >
                <span className="-type--large">
                    <Icon glyph="pencil-alt-regular" type="FontAwesome" />
                </span>
                <span className="-visually-hidden">Change team</span>
            </button>
            <button
                type="button"
                className="team-role-card-selected-extra-title__button"
                onClick={() => {
                    setFieldValue("Registration_Role", []);
                    setFieldValue("Team", "");
                    dispatch(setAppShowRemainingForm(false));
                }}
                aria-label="Change role"
            >
                <span className="-type--large">
                    <Icon glyph="trash-alt-regular" type="FontAwesome" />
                </span>
                <span className="-visually-hidden">Change role</span>
            </button>
        </div>
    );
};

SelectedTeamRoleCardExtraTitle.propTypes = {
    setAppTeamModalOpen: PropTypes.func.isRequired,
};

export default SelectedTeamRoleCardExtraTitle;
